import React, {useState, useEffect} from "react";
import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Series,
  ValueAxis,
  Legend,
  Label,
  Tick,
  Title,
  Size,
  Tooltip as DxTooltip
} from "devextreme-react/chart";

import DataGrid, {
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  Selection,
  FilterPanel
} from 'devextreme-react/data-grid';

import TreeList, {
  Column as TreeListColumn,
  SearchPanel,
  Selection as TreeListSelection
} from "devextreme-react/tree-list";



const analyzeTabData = {
        "treeListData": [
            {
                "name": "State A",
                "total_dwell_time": 456,
                "count": 83,
                "total_time_diff": 28472,
                "id": "42e5437a-1e9d-488d-a5b2-45a380256c78",
                "avg": 343
            },
            {
                "name": "State B",
                "total_dwell_time": 504,
                "count": 88,
                "total_time_diff": 30240,
                "id": "d97451fc-b77a-4e20-a36e-4e8da0b7b043",
                "avg": 344
            },
            {
                "name": "State C",
                "total_dwell_time": 544,
                "count": 88,
                "total_time_diff": 30148,
                "id": "89cd2d91-4c98-4981-8cc9-6af0b069a884",
                "avg": 343
            },
            {
                "name": "State D",
                "total_dwell_time": 428,
                "count": 75,
                "total_time_diff": 25728,
                "id": "b00d6d00-c0cb-478a-a2f8-963492a03408",
                "avg": 343
            }
        ],
        "rawData": [
            {
                "dwell_time": 10,
                "name": "State A",
                "process_state_dwell_start": "2024-09-29T20:21:20.137Z",
                "process_time": 339
            },
            {
                "dwell_time": 10,
                "name": "State B",
                "process_state_dwell_start": "2024-09-26T20:21:03.648Z",
                "process_time": 342
            },
            {
                "dwell_time": 8,
                "name": "State C",
                "process_state_dwell_start": "2024-09-26T20:21:01.180Z",
                "process_time": 342
            },
            {
                "dwell_time": 6,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:07.310Z",
                "process_time": 347
            },
            {
                "dwell_time": 1,
                "name": "State A",
                "process_state_dwell_start": "2024-09-23T20:21:07.383Z",
                "process_time": 345
            },
            {
                "dwell_time": 10,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:06.631Z",
                "process_time": 347
            },
            {
                "dwell_time": 10,
                "name": "State C",
                "process_state_dwell_start": "2024-09-22T20:21:06.932Z",
                "process_time": 346
            },
            {
                "dwell_time": 1,
                "name": "State C",
                "process_state_dwell_start": "2024-09-22T20:21:07.163Z",
                "process_time": 346
            },
            {
                "dwell_time": 6,
                "name": "State D",
                "process_state_dwell_start": "2024-09-30T20:21:01.632Z",
                "process_time": 338
            },
            {
                "dwell_time": 9,
                "name": "State C",
                "process_state_dwell_start": "2024-09-30T20:21:08.966Z",
                "process_time": 338
            },
            {
                "dwell_time": 1,
                "name": "State D",
                "process_state_dwell_start": "2024-09-22T20:21:08.739Z",
                "process_time": 346
            },
            {
                "dwell_time": 9,
                "name": "State A",
                "process_state_dwell_start": "2024-09-23T20:21:08.585Z",
                "process_time": 345
            },
            {
                "dwell_time": 6,
                "name": "State D",
                "process_state_dwell_start": "2024-09-21T20:21:08.659Z",
                "process_time": 347
            },
            {
                "dwell_time": 2,
                "name": "State C",
                "process_state_dwell_start": "2024-09-25T20:21:23.888Z",
                "process_time": 343
            },
            {
                "dwell_time": 9,
                "name": "State B",
                "process_state_dwell_start": "2024-09-23T20:21:06.405Z",
                "process_time": 345
            },
            {
                "dwell_time": 2,
                "name": "State D",
                "process_state_dwell_start": "2024-09-23T20:21:11.224Z",
                "process_time": 345
            },
            {
                "dwell_time": 8,
                "name": "State A",
                "process_state_dwell_start": "2024-09-25T20:21:12.783Z",
                "process_time": 343
            },
            {
                "dwell_time": 10,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:13.606Z",
                "process_time": 347
            },
            {
                "dwell_time": 9,
                "name": "State A",
                "process_state_dwell_start": "2024-09-23T20:21:15.854Z",
                "process_time": 345
            },
            {
                "dwell_time": 8,
                "name": "State A",
                "process_state_dwell_start": "2024-09-21T20:21:16.078Z",
                "process_time": 347
            },
            {
                "dwell_time": 5,
                "name": "State B",
                "process_state_dwell_start": "2024-09-22T20:21:16.529Z",
                "process_time": 346
            },
            {
                "dwell_time": 8,
                "name": "State B",
                "process_state_dwell_start": "2024-09-26T20:21:00.498Z",
                "process_time": 342
            },
            {
                "dwell_time": 8,
                "name": "State A",
                "process_state_dwell_start": "2024-09-26T20:21:01.026Z",
                "process_time": 342
            },
            {
                "dwell_time": 1,
                "name": "State C",
                "process_state_dwell_start": "2024-09-29T20:21:01.407Z",
                "process_time": 339
            }
        ]
    }


const AnalyzePanel = () => {

  // State variables for the analyze tab
  const [selectedStates, setSelectedStates] = useState('process_state');
  const [selectedAttributes, setSelectedAttributes] = useState('dwell_time');
  const [histogramData, setHistogramData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [selectedProcessState, setSelectedProcessState] = useState('State A'); // Set default selected state
  const [dataTree, setTreeData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [dynamicCaption, setDynamicCaption] = useState('Process State');
  const [dynamicCaption3, setDynamicCaption3] = useState('Dwell Time (Avg Days)');

  // Groups and attributes configuration
  const groups = [{"id":"process_state", "name":"Process State"},{"id":"space", "name":"Space"}];
  const attributes = [{id:'dwell_time', name: 'Dwell Time'}];

  // Calculate histogram data function
  const calculateHistogramData = (data) => {
    if (!data || data.length === 0) {
      return [];
    }
  
    // Extract process_time values, filtering out invalid ones
    const processTimes = data.map(item => item.process_time).filter(pt => pt !== null && pt !== undefined);
  
    if (processTimes.length === 0) {
      return []; // Handle case where all process_time values are null or undefined
    }
  
    // Calculate min and max values for process_time
    const max_data_value = Math.max(...processTimes);
    const min_data_value = Math.min(...processTimes);
  
    // Define bin configuration
    const num_bins = 10; // Fixed number of bins
    const bin_width = Math.ceil((max_data_value - min_data_value) / num_bins) || 1; // Avoid division by zero
  
    // Create bins
    const bins = Array.from({ length: num_bins }, (_, i) => ({
      range: min_data_value + i * bin_width,
      count: 0,
    }));
  
    // Assign each process_time to the appropriate bin
    processTimes.forEach((process_time) => {
      for (let i = 0; i < bins.length; i++) {
        if (i === bins.length - 1 || process_time < bins[i + 1].range) {
          bins[i].count++;
          break;
        }
      }
    });
  
    // Fill empty bins with zero count up to the max range
    const filledBins = bins.map(bin => ({
      range: bin.range.toString(), // Convert range to string
      count: bin.count,
    }));
  
    return filledBins;
  };

  // Initialize data from analyzeTabData
  useEffect(() => {
    setTreeData(analyzeTabData.treeListData);
    setRawData(analyzeTabData.rawData);
    
    // Initialize histogram data with State A data
    const initialStateData = analyzeTabData.rawData.filter(item => item.name === 'State A');
    if (initialStateData.length > 0) {
      const initialHistogram = calculateHistogramData(initialStateData);
      setHistogramData(initialHistogram);
    }
  }, []);

  // Update dynamic captions based on selections
  useEffect(() => {
    if (selectedStates) {
      const caption = groups.find(item => item.id === selectedStates);
      setDynamicCaption(caption ? caption.name : 'Select a Column'); 
      const caption3 = attributes.find(item => item.id === selectedAttributes);
      setDynamicCaption3(caption3 ? caption3.name && caption3.name === "Dwell Time" ? "Dwell Time (Avg Days)" : caption3.name : 'Select a Column'); 
    } else {
      setDynamicCaption('Select a Column');
      setDynamicCaption3('Select a Column');
    }
  }, [selectedStates, selectedAttributes]);

  // Handle state change
  const handleStateChange = (e) => {
    console.log('value of selected states: ', e.value);
    setSelectedStates(e.value);
  };

  // Handle attribute change
  const handleAttributeChange = (e) => {
    console.log('value of selected attributes: ', e.value);
    setSelectedAttributes(e.value);
  };

  // Handle selection change in TreeList
  const handleSelectionChanged = (e) => {
    // Check if selectedRowsData array exists and has at least one element
    if (e.selectedRowsData && e.selectedRowsData.length > 0) {
      const selectedState = e.selectedRowsData[0].name;
      
      // Check if selectedState is not undefined or null
      if (selectedState != null) {
        setSelectedProcessState(selectedState);
        
        // Filter rawData based on selected name
        const filteredData = analyzeTabData.rawData.filter(item => item.name === selectedState);
        
        console.log('filteredData: ', filteredData);
        
        // Update selectedRowKeys
        setSelectedRowKeys(e.selectedRowKeys);
        
        // Check if filteredData has elements before calculating histogram
        if (filteredData.length > 0) {
          const histogram = calculateHistogramData(filteredData);
          setHistogramData(histogram);
        } else {
          setHistogramData([]);
        }
      } else {
        console.warn('Selected row does not have a name property');
        setHistogramData([]);
      }
    } else {
      console.warn('No row selected');
      setSelectedProcessState(null);
      setSelectedRowKeys([]);
      setHistogramData([]);
    }
  };

  // Customize tooltip for chart
  const customizeEventsLabel = (arg) => {
    return {
      text: `${arg.valueText}`,
    };
  };


  return(
    <>
    <div style={{ padding: "10px" }}>
      {/* Selection controls */}
      
      {/* <div style={{ marginBottom: "20px", display: "flex", gap: "20px" }}>
        <div style={{ width: "250px" }}>
          <SelectBox
            style={{ width: '100%' }}
            value={selectedStates}
            onValueChanged={handleStateChange}
            dataSource={groups}
            labelMode="static"
            label="Grouping"
            stylingMode="outlined"
            valueExpr="id"
            displayExpr="name"
          />
        </div>
        <div style={{ width: "250px" }}>
          <SelectBox
            style={{ width: '100%' }}
            value={selectedAttributes}
            onValueChanged={handleAttributeChange}
            dataSource={attributes}
            labelMode="static"
            label="Attribute Analyzed"
            stylingMode="outlined"
            valueExpr="id"
            displayExpr="name"
          />
        </div>
      </div> */}

      {/* TreeList */}
      {selectedAttributes && selectedStates ? (
        <TreeList
          dataSource={dataTree}
          idField="name"
          defaultExpandedRowKeys={[]}
          showRowLines={true}
          showBorders={true}
          className='analyze-treelist'
          scrolling={{ mode: 'standard', showScrollbar: 'always' }}
          // height={'calc(100vh - 400px)'}
          height={'200px'}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={handleSelectionChanged}
          style={{ marginBottom: "20px" }}
        >
          <TreeListColumn 
            dataField="name" 
            caption={dynamicCaption || 'Select a Column'} 
          />
          <TreeListColumn dataField="count" caption="Asset Count" alignment="center" />
          <TreeListColumn 
            dataField="avg" 
            alignment="center" 
            caption={dynamicCaption3} 
          />
          <SearchPanel visible={false} />
          <TreeListSelection mode="single" />
        </TreeList>
      ) : ""}

      {/* Chart - Always visible with static data */}
      <div style={{ width: "100%", marginTop: "20px" }}>
        <h5 style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
          Asset Count by Dwell Time For {selectedProcessState}
        </h5>
        <Chart
          dataSource={histogramData}
          idField="process_state"
          width={'100%'}
          legend={{ visible: false }}
          style={{"--height": "500px"}}
          animation={{"enabled": false}} 
        >
          <CommonSeriesSettings
            argumentField="range"
          />
          <DxTooltip
            enabled={true}
            horizontalAlignment="left"
            customizeTooltip={customizeEventsLabel}
          />
          <Size
            width={'100%'}
            height={250}
          />
          <Series
            argumentField="range"
            valueField="count"
            name=""
            type="bar"
            color="#FFC001"
          />
          <ArgumentAxis 
            visible={true} 
            discreteAxisDivisionMode="crossLabels"
            type="discrete"
            label={{
              overlappingBehavior: 'none',
              alignment: 'center',
            }}
          >
            <Label overlappingBehavior="none" alignment="center">
              {item => {
                return `${item.value}`;
              }}
            </Label>
            <Tick visible={true} />
            <Title text="Dwell Time (Avg Days)"></Title>
          </ArgumentAxis>
          <ValueAxis
            visible={true}
            tickInterval={1}
            min={0}
            max={histogramData.length > 0 ? Math.max(...histogramData.map(item => item.count)) + 1 : 10}
          >
            <Label />
            <Title text="Asset Count" />
          </ValueAxis>
        </Chart>
      </div>
    </div>
    </>
  ) 
}

export default AnalyzePanel;